/**
 * What one block may need to know about the reply it sits in.
 *
 * Each fenced block is parsed on its own, but some only make sense beside the
 * others: a diagnostic card compares "88.1%" with Target and Etsy without
 * saying whose 88.1% it is. The brand is named once, in the reply's KPI grid
 * or funnel, and this carries it to the cards that leave it out.
 */

import { createContext, useContext } from "react";

const ReplyContext = createContext({ brand: undefined });

/** The brand a reply is about, from the first block that names one. */
export const brandOf = (text) =>
  typeof text === "string"
    ? /```(?:brand-kpi-grid|conversion-funnel)[\s\S]*?"brand"\s*:\s*"([^"]+)"/.exec(text)?.[1]
    : undefined;

export const useReply = () => useContext(ReplyContext);

export default ReplyContext;
